const { S2S_BIDDER_SUFFIX, s2sBidderSuffix, s2sBidderUnSuffix } = require('../misc/sharedConstants');

const RLV_PREFIX = '_rlv_';
const RLV_TARGET_PB_CFG_ID_KEY = 'relevant_pb_cfg_id';
const RLV_TARGET_PB_CFG_NAME_KEY = 'relevant_pb_cfg_name';

/**
 * An easy way to "generate" this list is by opening this URL in the browser:
 * - https://gitlab.relevant-digital.com/einar/prebid-server/-/tree/master/static/bidder-info
 * Then paste the following line in the console

	  console.info([...document.querySelectorAll('.tree-item-file-name > a > [class="position-relative"]')]
			.map((e) => e.innerText)
			.filter((s) => s.includes('yaml'))
			.map((s) => `\t'${s.split('.yaml')[0]}',`)
			.join('\n'))

 * ...and double-check that it seems right.
 */
const PBS_BIDDER_SUPPORT_LIST = [
	'152media',
	'1accord',
	'33across',
	'360playvid',
	'aax',
	'aceex',
	'acuityads',
	'adagio',
	'adastra',
	'addigi',
	'adelement',
	'adf',
	'adform',
	'adgeneration',
	'adhese',
	'adinify',
	'adipolo',
	'adkernel',
	'adkernelAdn',
	'adman',
	'admatic',
	'admaticde',
	'admixer',
	'adnimation',
	'adnuntius',
	'adot',
	'adpone',
	'adport',
	'adprime',
	'adquery',
	'adrino',
	'ads_interactive',
	'adsinteractive',
	'adsmovil',
	'adsyield',
	'adt',
	'adtarget',
	'adtelligent',
	'adtg_org',
	'adtonos',
	'adtrgtme',
	'aduptech',
	'advangelists',
	'adverxo',
	'adview',
	'adxcg',
	'adyoulike',
	'afront',
	'aidem',
	'aja',
	'akcelo',
	'alchemyx',
	'algorix',
	'alkimi',
	'alliance_gravity',
	'altstar',
	'amcom',
	'amx',
	'anzuExchange',
	'apacdex',
	'apester',
	'appMonstaMedia',
	'appStockSSP',
	'appnexus',
	'appstock',
	'appush',
	'artechnology',
	'aso',
	'audienceNetwork',
	'automatad',
	'avocet',
	'axis',
	'axonix',
	'bcmint',
	'beachfront',
	'beintoo',
	'bematterfull',
	'beop',
	'between',
	'beyondmedia',
	'bidfuse',
	'bidgency',
	'bidmachine',
	'bidmatic',
	'bidmyadz',
	'bidscube',
	'bidsmind',
	'bidstack',
	'bidtheatre',
	'bigoad',
	'blasto',
	'bliink',
	'blis',
	'blue',
	'bluesea',
	'bmtm',
	'boldwin',
	'boldwin_rapid',
	'brave',
	'bwx',
	'cadent_aperture_mx',
	'ccx',
	'clydo',
	'cointraffic',
	'coinzilla',
	'colossus',
	'compass',
	'concert',
	'connatix',
	'connectad',
	'connektai',
	'consumable',
	'contxtful',
	'conversant',
	'copper6',
	'copper6ssp',
	'cpmstar',
	'criteo',
	'cwire',
	'datablocks',
	'decenterads',
	'deepintent',
	'definemedia',
	'dianomi',
	'displayio',
	'dmx',
	'dpai',
	'driftpixel',
	'e_volution',
	'easybid',
	'edge226',
	'elementaltv',
	'embimedia',
	'emtv',
	'emx_digital',
	'eplanning',
	'epom',
	'epsilon',
	'equativ',
	'escalax',
	'evtech',
	'exco',
	'feedad',
	'felixads',
	'filmzie',
	'finative',
	'flatads',
	'flipp',
	'freewheel-ssp',
	'freewheelssp',
	'frvradn',
	'fwssp',
	'gamma',
	'gamoshi',
	'globalsun',
	'goldbach',
	'gravite',
	'greedygame',
	'grid',
	'gumgum',
	'harion',
	'harrenmedia',
	'huaweiads',
	'iionads',
	'imds',
	'impactify',
	'improvedigital',
	'indicue',
	'infytv',
	'inmobi',
	'insticator',
	'intenze',
	'interactiveoffers',
	'invibes',
	'iqx',
	'iqzone',
	'ix',
	'jambojar',
	'janet',
	'jdpmedia',
	'jixie',
	'kargo',
	'kayzen',
	'kidoz',
	'kiviads',
	'kobler',
	'krushmedia',
	'kuantyx',
	'kueezrtb',
	'lemmadigital',
	'limelightDigital',
	'lm_kiviads',
	'lockerdome',
	'logan',
	'logicad',
	'loopme',
	'loyal',
	'lunamedia',
	'mabidder',
	'madsense',
	'madvertise',
	'magnite',
	'markapp',
	'marsmedia',
	'mediafuse',
	'mediago',
	'medianet',
	'mediasquare',
	'mediayo',
	'melozen',
	'metax',
	'mgid',
	'mgidX',
	'minutemedia',
	'missena',
	'mobfoxpb',
	'mobilefuse',
	'mobkoi',
	'monetixads',
	'motorik',
	'msft',
	'mycodemedia',
	'nativery',
	'nativo',
	'netaddiction',
	'nextmillennium',
	'nexx360',
	'nobid',
	'nuba',
	'ogury',
	'omnidex',
	'oms',
	'onetag',
	'openweb',
	'openx',
	'operaads',
	'optidigital',
	'oraki',
	'orangeclickmedia',
	'orbidder',
	'outbrain',
	'oveeo',
	'ownadx',
	'pangle',
	'performist',
	'pgam',
	'pgamssp',
	'pinkLion',
	'pixad',
	'playdigo',
	'prismassp',
	'programmaticX',
	'progx',
	'pubmatic',
	'pubnative',
	'pubrise',
	'pulsepoint',
	'pwbid',
	'qt',
	'quantumdex',
	'radiantfusion',
	'readpeak',
	'rediads',
	'relevantdigital',
	'resetdigital',
	'revcontent',
	'richaudience',
	'rise',
	'robustApps',
	'rocketlab',
	'roulax',
	'rtbdemand',
	'rtbhouse',
	'rubicon',
	'rxnetwork',
	'sa_lunamedia',
	'screencore',
	'seedingAlliance',
	'seedtag',
	'sharethrough',
	'showheroes-bs',
	'showheroes',
	'showheroesBs',
	'silvermob',
	'silverpush',
	'smaato',
	'smartadserver',
	'smarthub',
	'smartrtb',
	'smartx',
	'smartyads',
	'smilewanted',
	'smoot',
	'smootai',
	'smrtconnect',
	'sonobi',
	'sovrn',
	'sovrnXsp',
	'sparteo',
	'sspBC',
	'startio',
	'streamkey',
	'streamlyn',
	'streamvision',
	'stroeerCore',
	'suntContent',
	'synacormedia',
	'taboola',
	'tagoras',
	'tappx',
	'teads',
	'telaria',
	'teqblaze',
	'tgm',
	'theadx',
	'thetradedesk',
	'tpmn',
	'tradplus',
	'trafficgate',
	'tredio',
	'triplelift',
	'triplelift_native',
	'trustedstack',
	'trustx',
	'ttd',
	'ucfunnel',
	'undertone',
	'unicorn',
	'unruly',
	'valueimpression',
	'velonium',
	'verben',
	'vidazoo',
	'videobyte',
	'videoheroes',
	'vidoomy',
	'viewdeos',
	'visiblemeasures',
	'visx',
	'vox',
	'vrtcal',
	'vungle',
	'xapads',
	'xeworks',
	'xtrmqb',
	'yahooAds',
	'yahooAdvertising',
	'yahoossp',
	'yandex',
	'yeahmobi',
	'yieldlab',
	'yieldmo',
	'yieldone',
	'yobee',
	'zentotem',
	'zeroclickfraud',
	'zeta_global_ssp',
	'zmaticoo',
];

const rlvPrefix = (name) => `${RLV_PREFIX}${name}`;
const renameToInternalParams = (arr) => arr.map((e) => ({ ...e, name: rlvPrefix(e.name) }));

const MEDIA_TYPE_OPTIONS = [
	{ value: 'mixed', label: 'Mixed' },
	{ value: 'banner', label: 'Banner' },
	{ value: 'video', label: 'Video' },
	{ value: 'native', label: 'Native' },
];

const BASE_INTERNAL_BID_TAG_FIELDS = [
	{
		type: 'Boolean',
		fields: [],
		description: 'Disable Bidder',
		defaultValue: false,
		name: 'disableBidder',
		renderBeforeData: 'renderBeforeDisableBidder',
	},
	{
		type: 'Boolean',
		fields: [],
		description: 'Disable Outstream video in multi-format placements',
		defaultValue: false,
		name: 'mixedFormatDisableVideo',
	},
	{
		type: 'String',
		fields: [],
		description: 'Limit media type override',
		defaultValue: null,
		name: 'mtOverride',
		hasOptions: true,
		options: MEDIA_TYPE_OPTIONS.map(({ value, label }) => ({ name: value, label })),
		props: {
			help: 'Sets the default media type limit setting for the SSP, which decides what value to use for SSP-placements with \'Limit media type\' = \'Auto\'',
		},
	},
];

const BASE_BIDDING_TYPE_OPTION = {
	type: 'String',
	fields: [],
	description: 'Bidding type',
	defaultValue: 'client',
	name: 'biddingType',
	hasOptions: true,
	isRequired: true,
	options: [
		{ name: 'client', label: 'Client-side' },
	],
};

const BASE_USER_ID_MODULE_PARAMS = [
	{
		type: 'Object',
		name: 'storage',
		description: 'Storage',
		fields: [
			{
				type: 'String',
				name: 'type',
				description: 'Type',
				hasOptions: true,
				options: [
					{
						name: 'html5',
						label: 'Local storage',
					},
					{
						name: 'cookie',
						label: 'Cookie',
					},
					{
						name: 'cookie&html5',
						label: 'Local storage and cookie',
					},
				],
				defaultValue: 'html5',
				isRequired: true,
			},
			{
				type: 'Number',
				name: 'expires',
				description: 'Storage time (days)',
				isRequired: true,
				defaultValue: 30,
			},
			{
				type: 'Number',
				name: 'refreshInSeconds',
				description: 'Time before refresh (seconds)',
				isRequired: false,
				defaultValue: 86400,
			},
		],
	},
	{
		type: 'Array',
		name: 'bidders',
		description: 'Allowed bidders',
		isRequired: false,
		fields: [{
			type: 'String',
			name: 'bidder',
			description: 'Bidder',
			defaultValue: '',
		}],
	},
];

const PLACEMENT_UI_GROUPS = {
	BUILT_IN: 'Built-in settings',
	ADV_ORDER: 'Advertiser/Order',
	EMPTY_RELOAD: 'Extra reloading when no ad is returned',
};

module.exports = {
	RLV_PREFIX,
	RLV_TARGET_PB_CFG_ID_KEY,
	RLV_TARGET_PB_CFG_NAME_KEY,
	BASE_INTERNAL_BID_TAG_FIELDS,
	BASE_BIDDING_TYPE_OPTION,
	rlvPrefix,
	renameToInternalParams,
	S2S_BIDDER_SUFFIX,
	s2sBidderSuffix,
	s2sBidderUnSuffix,
	PBS_BIDDER_SUPPORT_LIST,
	BASE_USER_ID_MODULE_PARAMS,
	MEDIA_TYPE_OPTIONS,
	PLACEMENT_UI_GROUPS,
};
